import type { FC, PropsWithChildren } from 'react';

import styles from './SearchResultsDropdown.scss';

export const SearchResultsDropdown: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.resultsDropdown}>{children}</div>
);
